import { requests, requestStates } from "../../constants/requests";
import { normalizeTransferCode } from "../../utils/transfer-code";
import { apiFetch, errorMessage, noop, reportTo, run } from "../api";
import {
  getGroupStatus,
  outboxCleared,
  refreshGroups,
  selectCurrentGroupId,
  selectSessionId,
  setGroupLoadedAt,
  setGroups,
  setRequestState,
  setSessionId,
  showGroup,
} from "./app-slice";

const track = (dispatch, state) =>
  dispatch(setRequestState({ [requests.redeemTransferCode]: state }));

export const createTransferCode =
  (onSuccess = noop, onError = noop) =>
  (dispatch, getState) =>
    run(
      apiFetch(selectSessionId(getState()), "/session-transfer", {
        method: "POST",
      }),
      onSuccess,
      reportTo(onError, "Der Code konnte nicht erstellt werden."),
    );

export const switchSession = (sessionId) => (dispatch) => {
  dispatch(showGroup(null));
  dispatch(setGroups([]));
  dispatch(setGroupLoadedAt(null));
  dispatch(outboxCleared());
  dispatch(setSessionId(sessionId));
};

export const redeemTransferCode =
  (code, onSuccess = noop, onError = noop) =>
  (dispatch, getState) => {
    track(dispatch, requestStates.sent);
    return run(
      apiFetch(
        selectSessionId(getState()),
        `/session-transfer/${normalizeTransferCode(code)}`,
        { method: "POST" },
      ),
      ({ sessionId }) => {
        dispatch(switchSession(sessionId));
        track(dispatch, requestStates.success);
        onSuccess();
        return dispatch(
          refreshGroups(([first] = []) => {
            if (first && !selectCurrentGroupId(getState())) {
              dispatch(getGroupStatus(first.id, true));
            }
          }),
        );
      },
      (error) => {
        track(dispatch, requestStates.error);
        onError(errorMessage(error, "Der Code konnte nicht eingelöst werden."));
      },
    );
  };
